// // // actions/themeActions.js

// // import { SET_THEME } from "./ThemeAction";

 


// // // reducers/themeReducer.js
// // const initialState = { 
// //   theme: 'blue', // Default theme 
// // };

// // const themeReducer = (state = initialState, action) => {
// //   switch (action.type) {
// //     case SET_THEME:
// //       return {
// //         ...state,
// //         theme: action.payload,
// //       };
// //     default:
// //       return state;
// //   }
// // };

// // export default themeReducer;

// // themeReducer.js

// // export const themes = {
// //   blue: {
// //     colorPrimary: "#1890ff",
// //     colorPrimaryHover: "#096dd9",
// //   },
// //   green: {
// //     colorPrimary: "#52c41a",
// //     colorPrimaryHover: "#40a700",
// //     secondaryColor:"#ECFDF3"
// //   },
// //   red: {
// //     colorPrimary: "#ff4d4f",
// //     colorPrimaryHover: "#d9363e",
// //   },
// //   purple: {
// //     colorPrimary: "#722ed1",
// //     colorPrimaryHover: "#531dab",
// //   },
// //   orange: {
// //     colorPrimary: "#fa8c16",
// //     colorPrimaryHover: "#d46b08",
// //   },
// // };
// export const themes = {
//   blue: {
//     colorPrimary: "#15c5ea",
//     // colorPrimary: "#1890ff",
//     colorPrimaryHover: "#096dd9",
//     colorPrimaryShade: "#bae7ff",     // lighter shade
//     secondaryColor: "#e6f7ff",
//   },
//   green: {
//     colorPrimary: "#52c41a",
//     colorPrimaryHover: "#40a700",
//     colorPrimaryShade: "#d9f7be",     // lighter shade
//     secondaryColor: "#ECFDF3",
//   },
//   red: {
//     colorPrimary: "#ff4d4f",
//     colorPrimaryHover: "#d9363e",
//     colorPrimaryShade: "#ffccc7",     // lighter shade
//     secondaryColor: "#fff1f0",
//   },
//   purple: {
//     colorPrimary: "#722ed1",
//     colorPrimaryHover: "#531dab",
//     colorPrimaryShade: "#d3adf7",     // lighter shade
//     secondaryColor: "#f9f0ff",
//   },
// };



// const initialState = {
//   currentTheme: "green", // Default theme
//   themeConfig: themes.green,
// };

// const themeReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case "SET_THEME":
//       return {
//         ...state,
//         currentTheme: action.payload,
//         themeConfig: themes[action.payload] || themes.green, // Fallback to blue if invalid theme
//       };
//     default:
//       return state;
//   }
// };

// export default themeReducer;

import tinycolor from "tinycolor2";

export const themes = {
  blue: {
    colorPrimary: "#15c5ea",
    colorPrimaryHover: "#096dd9",
    colorPrimaryShade: tinycolor("#15c5ea").lighten(20).toHexString(),
    // colorPrimaryShade: "#4aa8d4",
    secondaryColor: "#77a8bf",
  },
  green: {
    colorPrimary: "#258a79",
    colorPrimaryHover: "#258a79",
    colorPrimaryShade: tinycolor("#258a79").lighten(20).toHexString(),
    // colorPrimaryShade: "#d9f7be",
    secondaryColor: "#1eeb73",
  },
  red: {
    colorPrimary: "#ff4d4f",
    colorPrimaryHover: "#d9363e",
    colorPrimaryShade: tinycolor("#ff4d4f").lighten(20).toHexString(),
    // colorPrimaryShade: "#ffccc7",
    secondaryColor: "#f5aca6",
  },
  purple: {
    colorPrimary: "#722ed1",
    colorPrimaryHover: "#531dab",
    colorPrimaryShade: tinycolor("#722ed1").lighten(20).toHexString(),
    // colorPrimaryShade: "#d3adf7",
    secondaryColor: "#c983f7",
  },
};

const initialState = {
  currentTheme: "green", // Default theme
  themeConfig: themes.green,
};

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_THEME":
      return {
        ...state,
        currentTheme: action.payload,
        themeConfig: themes[action.payload] || themes.green,
      };

    case "SET_CUSTOM_THEME":
      const base = tinycolor(action.payload);
      return {
        ...state,
        currentTheme: "custom",
        themeConfig: {
          colorPrimary: base.toHexString(),
          colorPrimaryHover: base.darken(10).toHexString(),
          colorPrimaryShade: base.lighten(20).toHexString(),
          secondaryColor: base.darken(5).toHexString(),
        },
      };

    default:
      return state;
  }
};

export default themeReducer;
